
export default {
    name: 'OrderMoneyProgressBar',
    props: {
        currentAmount: {
            type: Number,
            reqiured: true
        },
        needAmount: {
            type: Number,
            reqiured: true
        },
        border: {
            type: Number,
            default: 80
        }
    },
    computed: {
        percent() {
            const onePercent = this.needAmount / 100 ;
            return (Math.floor(this.currentAmount / onePercent)).toFixed(0);
        }
    },
};
